"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const _util_1 = require("../_util");
const loading_1 = __importDefault(require("../loading"));
const icon_1 = __importDefault(require("../icon"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('btn');
const ButtonTypes = _util_1.tuple('default', 'primary');
const AButton = (props) => {
    const { type, size, className, style, children, onTap, disabled, danger, shape, block, float, loading, loadingText, plain, hairline, look, color, icon, ghost } = props, restProps = __rest(props, ["type", "size", "className", "style", "children", "onTap", "disabled", "danger", "shape", "block", "float", "loading", "loadingText", "plain", "hairline", "look", "color", "icon", "ghost"]);
    const handleTap = (e) => {
        if (disabled) {
            return;
        }
        if (loading) {
            return;
        }
        onTap === null || onTap === void 0 ? void 0 : onTap(e);
    };
    const renderIcon = (childrenElement) => {
        var _a;
        let iconSize = '32px';
        if (size === 'small') {
            iconSize = '28px';
        }
        if (size === 'large') {
            iconSize = '36px';
        }
        let iconColor = '#1890FF';
        if (type === 'primary') {
            iconColor = '#FDFFFD';
        }
        if (plain) {
            if (type === 'primary') {
                iconColor = '#1890FF';
            }
            if (color) {
                iconColor = color;
            }
        }
        if (typeof icon === 'string') {
            return (React.createElement(icon_1.default, { type: icon, color: iconColor, size: iconSize, style: { verticalAlign: '-0.05em', marginRight: childrenElement ? '6px' : undefined } }));
        }
        if (React.isValidElement(icon)) {
            return Object.assign(Object.assign({}, icon), { props: Object.assign(Object.assign({}, icon === null || icon === void 0 ? void 0 : icon.props), { style: Object.assign({ verticalAlign: '-0.05em', marginRight: childrenElement ? '6px' : undefined }, (_a = icon === null || icon === void 0 ? void 0 : icon.props) === null || _a === void 0 ? void 0 : _a.style) }) });
        }
        return null;
    };
    const classes = classnames_1.default(prefixCls, className, {
        [`${prefixCls}-${shape}`]: shape,
        [`${prefixCls}-${size}`]: size,
        [`${prefixCls}-primary`]: type === 'primary',
        [`${prefixCls}-ghost`]: ghost,
        [`${prefixCls}-plain`]: plain,
        [`${prefixCls}-hairline`]: hairline,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-float`]: float,
        [`${prefixCls}-float-${float}`]: float,
        [`${prefixCls}-danger-default`]: danger,
        [`${prefixCls}-danger`]: type === 'primary' && danger,
        [`${prefixCls}-look-${look}`]: look,
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-disabled`]: disabled || loading,
    });
    const childrenElement = loading && loadingText ? loadingText : children;
    const iconElement = renderIcon(childrenElement);
    return (React.createElement(one_1.Button, Object.assign({ className: classes, disabled: disabled, onTap: handleTap, style: Object.assign(Object.assign({}, style), { color, borderColor: color }) }, restProps),
        loading ? (React.createElement(one_1.View, { className: `${prefixCls}-loading-icon` },
            React.createElement(loading_1.default, { color: "#FDFFFD", radius: "36px", style: { verticalAlign: '-0.3em' } }))) : (iconElement),
        React.createElement(one_1.Text, { className: `${prefixCls}-text` }, childrenElement),
        React.createElement(one_1.Text, { className: `${prefixCls}-mask` })));
};
exports.default = AButton;
